import { Icon } from "../../helpers/icons";

export const SectionHeader = ({ title, content, callFunc, funcName }) => {
    return (
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-3 px-2 py-1 app-listing-header min-w-0">
        <div className="flex flex-1 min-w-0 justify-between sm:justify-start items-center gap-2">
          <p className="font-bold truncate min-w-0">{title}</p>
          {callFunc && (
            <p
              className="py-1 px-2 text-white font-normal rounded hover:bg-success-hover cursor-pointer bg-success-hover shrink-0 touch-manipulation"
              onClick={callFunc}
            >
              {funcName && funcName}
            </p>
          )}
        </div>
        {content && (
          <div className="flex flex-wrap gap-2 sm:gap-x-1 flex-none min-w-0 items-center">
            {content}
          </div>
        )}
      </div>
    );
};
export const LoadingData = ({ msg }) => {
  return (
    <div className="p-4 text-center text-lg text-slate-400">
      {msg || "Loading..."} <Icon color="text-slate-400" type="inline-loader" />
    </div>
  );
};